import React from 'react';
import Drawer from './Drawer.jsx';
import EventHandler from '../utils/EventHandler'
import Slider from '../utils/Slider'

export default class SizeGuide extends React.PureComponent {
  constructor(props) {
    super();

    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ev = new EventHandler();
  }

  componentWillUnmount() {
    this.ev.unregisterAll();
  }

  componentDidUpdate() {
    if (this.ref.current && this.ref.current.contentRef && this.ref.current.contentRef.current) {
      this.ref.current.contentRef.current.querySelectorAll('[data-accordion]').forEach(e => {
        this.ev.register(e, 'click', (e) => {e.currentTarget.classList.toggle('expanded')})
      });
      const carousel = this.ref.current.contentRef.current.querySelector('.as-seen-on-carousel');
      if (carousel) {
        new Slider(carousel, {
          wrapAround: true,
        });
      }
      const swapTrigger = this.ref.current.contentRef.current.querySelector('#view-intl-sizing') || this.ref.current.contentRef.current.querySelector('#view-us-sizing');
      if (swapTrigger) {
        if (this.props.open) {
          if (this.swapEv) {
            this.ev.unregister(this.swapEv);
          }
          this.swapEv = this.ev.register(swapTrigger, 'click', this.props._swapSizeGuide);
        } else {
          this.ev.unregister(this.swapEv);
        }
      }
      const toggleMeasurement = this.ref.current.contentRef.current.querySelector('#toggle-measurements-2');
      if (toggleMeasurement) {
        this.ev.register(toggleMeasurement, 'change', (e) => {
          if (e.target.checked) {
            this.ref.current.contentRef.current.querySelectorAll('[data-cm]').forEach(el => {
              el.textContent = el.dataset.cm
            })
          } else {
            this.ref.current.contentRef.current.querySelectorAll('[data-in]').forEach(el => {
              el.textContent = `${el.dataset.in}"`
            })
          }
        });
      }
    }
  }

  render() {
    return <Drawer ref={this.ref} open={this.props.open} content={this.props.content} _close={this.props._close} mountOnEnter={false} unmountOnExit={true} />
  }
}